import React, { Suspense, useMemo, useState, useEffect } from 'react';
import NavigationLayout from '../navigation/NavigationLayout';
import Modal from 'components/modal/Modal';
import Footer from 'components/footer/Footer';
import PasswordResetForm from 'components/password-reset-form/password-reset-form';
import EditProfileModal from 'components/edit-profile-contact-form/container/edit-profile-modal';
import SuccessAlertMessage from 'components/password-reset-form/success-alert-message/success-alert-message';
import pixels from 'util/pixels';

const MainLayout = ({ children, route }) => {
  const { path } = route;

  const excludeFooterRoutes = ['/parent-portal'];
  const showFooter = useMemo(() => !excludeFooterRoutes.includes(path), [path]);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);
  const [showPasswordAlert, setShowPasswordAlert] = useState(false);

  const openSettings = () => setIsSettingsOpen(!isSettingsOpen);

  const openResetPassword = () => setIsResetPasswordOpen(!isResetPasswordOpen);

  const passwordAlertStatusChange = () => {
    setShowPasswordAlert(true);
    // turn off alert in board after 3 seconds
    setTimeout(() => setShowPasswordAlert(false), 3000);
  };

  return (
    <Suspense
      fallback={
        <Modal isVisible className="modal-loading">
          <div className="img-loading-search" style={{ display: 'block' }}>
            <img src="https://static.schola.com/LoadingAnimation200Opt.gif" alt="schola loading" loading="lazy" />
          </div>
        </Modal>
      }>
      <div className="schola-v3 layoutv3">
        <NavigationLayout openSettings={openSettings} openResetPassword={openResetPassword} />
        <div className="main_content">
          {showPasswordAlert && <SuccessAlertMessage />}
          {/* {children} */}
          {React.cloneElement(children, {
            isSettingsOpen,
            openSettings,
            isResetPasswordOpen,
            openResetPassword,
            showPasswordAlert,
            passwordAlertStatusChange,
          })}
        </div>
        {isSettingsOpen && <EditProfileModal isVisible={isSettingsOpen} onClose={openSettings} />}
        {isResetPasswordOpen && (
          <PasswordResetForm
            isVisible={isResetPasswordOpen}
            onClose={openResetPassword}
            passwordAlertStatusChange={passwordAlertStatusChange}
          />
        )}
        {showFooter && <Footer />}
      </div>
    </Suspense>
  );
};

export default MainLayout;
